/* eslint-disable max-lines */
/* eslint-disable max-len */

import { axios } from "../config/axios";
import { IAxiosResponse } from "../interfaces/IAxiosResponse";
import { IPagination } from "../interfaces/IPagination";
import { IEsimSalesOverview } from "../interfaces/esim/EsimOverview.types";
import { ICreatePackageModel, IEsimPackage, ILocationZoneResponse, IUpdatePackageModel } from "../interfaces/esim/EsimPackages.types";
import { EsimReservationsParams, IEsimProfile, IEsimReservation } from "../interfaces/esim/EsimReservations.types";
import { serialize } from "../utils/serializeToQueryString";

export const getEsimReservations = async (
  params: EsimReservationsParams
): Promise<IAxiosResponse<IPagination<IEsimReservation>>> => {
  return axios.get(`v1/Esim/Reservations${serialize(params)}`);
};

export const cancelPackage = async (
  uniqueReservationGuid: string,
  refundAmount?: number,
  refundInCredits?: boolean
): Promise<IAxiosResponse<number>> => {
  const amount = refundAmount !== undefined ? refundAmount : 0;
  return axios.post(`v1/Esim/CancelReservation/${uniqueReservationGuid}?refundAmount=${amount}&refundInCredits=${!!refundInCredits}`);
};

export const getEsimSalesOverview = async (params: {
  windowStart: string;
  windowEnd: string;
  locationZoneId?: number;
  packageTemplateId?: number;
  sourceChannel?: string;
}): Promise<IAxiosResponse<IEsimSalesOverview>> => {
  return axios.get(`v1/Esim/SalesOverview${serialize(params)}`);
};

export const getLocationZones = async (
  search: string,
  page: number = 1,
  pageSize: number = 10
): Promise<IAxiosResponse<ILocationZoneResponse>> => {
  return axios.get(`/v1/Esim/LocationZones/Autocomplete${serialize({ search, page, pageSize })}`);
};

export const getPackagesByLocationZone = async (
  locationZoneSlug: string
): Promise<IAxiosResponse<IEsimPackage[]>> => {
  return axios.get(`/v1/Esim/GetPackagesByLocationZone/${locationZoneSlug}`);
};

export const updatePackage = async (data: IUpdatePackageModel): Promise<IAxiosResponse<IEsimPackage>> => {
  return axios.put("/v1/Esim/UpdatePackage", data);
};

export const createPackage = async (data: ICreatePackageModel): Promise<IAxiosResponse<IEsimPackage>> => {
  return await axios.post("/v1/Esim/CreatePackage", data);
};

export const deletePackage = async (id: number) => {
  return await axios.delete(`/v1/Esim/DeletePackage/${id}`);
};

export const getPackageById = async (
  id: number
): Promise<IAxiosResponse<IEsimPackage>> => {
  return axios.get(`/v1/Esim/GetPackageById/${id}`);
};

export const getEsimProfile = async (profileId: number) => {
  const response = await axios.get<IEsimProfile>(`/v1/Esim/Profile/${profileId}`);
  return response.data;
};

export const updateEsimProfileEmail = async (esimProfileId: number, newEmail: string) => {
  return axios.put(`/v1/Esim/Profile/${esimProfileId}/UpdateEmail`, null, {
    params: { newEmail }
  });
};

export const resendEsimReservationEmail = async (reservationId: number) => {
  return axios.get(`/v1/Esim/Reservation/${reservationId}/ResendEmail`);
};
